import { PoChartOptions } from '@po-ui/ng-components';

/** Passos "redondos" do eixo: 1, 2, 5, 10, 20, 25, 50, 100... */
const STEP_BASES = [1, 2, 2.5, 5];

/** Mais intervalos que isso e as linhas de grade viram ruído. */
const MAX_INTERVALS = 5;

/**
 * Eixo de contagem com marcas inteiras e redondas. Sem isso o po-chart divide o maior
 * valor em quatro partes iguais e mostra "47,75" ou "2,75" — número de review que não
 * existe. Escolhe o menor passo redondo que cobre o maior valor em até cinco intervalos.
 */
export function integerAxis(values: number[]): PoChartOptions {
  const max = Math.max(0, ...values.filter(v => Number.isFinite(v)));
  if (max <= 0) { return {}; }
  for (let power = 1; ; power *= 10) {
    for (const base of STEP_BASES) {
      const step = base * power;
      if (!Number.isInteger(step)) { continue; }
      const intervals = Math.ceil(max / step);
      if (intervals <= MAX_INTERVALS) {
        return { axis: { minRange: 0, maxRange: step * intervals, gridLines: intervals + 1 } };
      }
    }
  }
}
